import * as React from 'react';
import styled from 'styled-components';
import * as _ from 'lodash/fp';
import tinycolor from 'tinycolor2';

import { ColorInput } from '@process-advisor/process-miner/components/shared/colorInput';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { type DiagramColorsProps } from '@process-advisor/process-miner/api/methods/settings/changeColors';
import { Event } from '@process-advisor/process-miner/api/events';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const StyledColorInput = styled(ColorInput)`
    margin-right: 30px;

    &:last-child {
        margin: 0
    }
`;

export const Colors = () => {
    const [
        initialColors,
        setInitialColors,
    ] = React.useState<DiagramColorsProps>({});
    let currentKey = '';
    const changeColor = _.curry((key: string, color: string) => {
        currentKey = key;
        apiProvider.changeColors({ [key]: tinycolor(color).toRgbString() });
    });

    const onClose = () => {
        if (currentKey !== 'visualizerBackgroundColor') {
            if (apiProvider.getActiveAction() ==='process_miner')  apiProvider.rebuildPVDiagram({});
        } else {
            apiProvider.eventEmitter.emit(Event.changeVisualizerBackgroundColor);
        }
    };

    React.useEffect(() => {
        setInitialColors(apiProvider.getColors());
    }, []);


    React.useEffect(() => {
        const listener = () =>
            setInitialColors(apiProvider.getColors());
        listener();

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Wrapper>
            <StyledColorInput
                id='step'
                onClose={onClose}
                onColorChange={changeColor('linkColor')}
                label='Step'
                color={initialColors.linkColor} />
            <StyledColorInput
                id='selectLink'
                onClose={onClose}
                onColorChange={changeColor('selectLinkColor')}
                label='Link Select'
                color={initialColors.selectLinkColor} />
            <StyledColorInput
                id='animate'
                onClose={onClose}
                onColorChange={changeColor('animateColor')}
                label='Animate'
                color={initialColors.animateColor} />
            <StyledColorInput
                id='loop'
                onClose={onClose}
                onColorChange={changeColor('loopColor')}
                label='Step Loops'
                color={initialColors.loopColor} />
            <StyledColorInput
                id='visualizerbackground'
                onClose={onClose}
                onColorChange={changeColor('visualizerBackgroundColor')}
                label='Visualizer Background'
                color={initialColors.visualizerBackgroundColor} />
            <StyledColorInput
                id='startnode'
                onClose={onClose}
                onColorChange={changeColor('startNodeColor')}
                label='Start Node'
                color={initialColors.startNodeColor} />
            <StyledColorInput
                id='endnode'
                onClose={onClose}
                onColorChange={changeColor('endNodeColor')}
                label='End Node'
                color={initialColors.endNodeColor} />
        </Wrapper>
    );
};
